import React from 'react';
import {Box, CircularProgress} from '@mui/material';

const TabLoading = () => (
    <Box sx={{display: 'flex', justifyContent: 'center', py: 4}}>
        <CircularProgress size={28}/>
    </Box>
);

export default TabLoading;

